import { HIDE_EDIT_PROFILE_MODAL, SHOW_EDIT_PROFILE_MODAL } from "../../constants/actions";

export const showEditProfileModal = () => ({
  type: SHOW_EDIT_PROFILE_MODAL,
});

export const hideEditProfileModal = () => ({
  type: HIDE_EDIT_PROFILE_MODAL,
});
